export const config = {
  API_URL: process.env.REACT_APP_API_URL || "http://localhost:3002/services",
  AMPLITUDE_API_KEY: process.env.REACT_APP_AMPLITUDE_API_KEY || "foobar",
}
